const routeChunks = {
  landing: () => import("../pages/LandingPage"),
  register: () => import("../pages/Register"),
  login: () => import("../pages/Login"),
  verifyEmailNotice: () => import("../pages/VerifyEmailNotice"),
  verifyEmail: () => import("../pages/VerifyEmail"),
  forgotPassword: () => import("../pages/ForgotPassword"),
  resetPassword: () => import("../pages/ResetPassword"),
  subscribe: () => import("../pages/SubscribePage"),
  billing: () => import("../pages/BillingPage"),
  settings: () => import("../pages/SettingsPage"),
  dashboard: () => import("../pages/Dashboard"),
  setupResume: () => import("../pages/SetupResume"),
  myResumes: () => import("../pages/MyResumes"),
  roleBasedResume: () => import("../pages/RoleBasedResume"),
  resumePreview: () => import("../pages/ResumePreviewPage"),
  publicResumePreview: () => import("../pages/PublicResumePreview"),
  resumeEdit: () => import("../pages/ResumeEditPage"),
  interviewPrep: () => import("../pages/InterviewPrep"),
  planDetails: () => import("../pages/PlanDetailsPage"),
  interviewPlans: () => import("../pages/InterviewPlans"),
  mockTest: () => import("../pages/MockTestPage"),
  profile: () => import("../pages/Profile"),
  jobApplications: () => import("../pages/JobApplications"),
  support: () => import("../pages/SupportPage"),
  supportLogin: () => import("../pages/SupportLogin"),
  supportPortal: () => import("../pages/SupportPortal"),
  supportSettings: () => import("../pages/SupportSettings"),
  supportAdmin: () => import("../pages/SupportAdminPortal"),
  superAdmin: () => import("../pages/SuperAdminPortal"),
  superAdminDepartments: () => import("../pages/SuperAdminDepartments"),
  superAdminEmployees: () => import("../pages/SuperAdminEmployees"),
  superAdminAssignments: () => import("../pages/SuperAdminAssignments"),
  superAdminRoles: () => import("../pages/SuperAdminRoles"),
  superAdminSupport: () => import("../pages/SuperAdminSupportIssues"),
  superAdminUsers: () => import("../pages/SuperAdminUsersAnalytics"),
  superAdminBilling: () => import("../pages/SuperAdminBilling"),
  superAdminAiUsage: () => import("../pages/SuperAdminAiUsage"),
  superAdminInstitutions: () => import("../pages/SuperAdminInstitutions"),
  superAdminInfluencers: () => import("../pages/SuperAdminInfluencers"),
  superAdminDomains: () => import("../pages/SuperAdminDomains"),
  superAdminCouponsScope: () => import("../pages/SuperAdminCouponsScope"),
  supportLogout: () => import("../pages/SupportLogout"),
  aiResumeBuilder: () => import("../pages/AiResumeBuilderPage"),
  jobApplicationsAssistant: () => import("../pages/JobApplicationsAssistantPage"),
  interviewPreparation: () => import("../pages/InterviewPreparationPage"),
};

const pathMap = {
  "/": "landing",
  "/features": "landing",
  "/launchpad": "landing",
  "/career-suite": "landing",
  "/register": "register",
  "/login": "login",
  "/verify-email": "verifyEmailNotice",
  "/forgot-password": "forgotPassword",
  "/subscribe": "subscribe",
  "/pricing": "subscribe",
  "/ai-resume-builder": "aiResumeBuilder",
  "/job-application-assistant": "jobApplicationsAssistant",
  "/interview-preparation": "interviewPreparation",
  "/billing": "billing",
  "/settings": "settings",
  "/dashboard": "dashboard",
  "/setup-resume": "setupResume",
  "/my-resumes": "myResumes",
  "/role-based-resume": "roleBasedResume",
  "/resume-preview": "resumePreview",
  "/share": "publicResumePreview",
  "/resume-edit": "resumeEdit",
  "/interview-prep": "interviewPrep",
  "/prep-plan": "planDetails",
  "/interview-plans": "interviewPlans",
  "/mock-test": "mockTest",
  "/profile": "profile",
  "/job-applications": "jobApplications",
  "/support": "support",
  "/u/support/login": "supportLogin",
  "/u/support/portal": "supportPortal",
  "/u/support/admin": "supportAdmin",
  "/u/support/admin/users": "superAdminUsers",
  "/u/support/admin/login": "supportLogin",
  "/u/support/admin/logout": "supportLogout",
  "/u/support/agent": "supportPortal",
  "/u/support/agent/login": "supportLogin",
  "/u/support/agent/logout": "supportLogout",
  "/u/support/settings": "supportSettings",
  "/u/super/admin": "superAdmin",
  "/u/super/admin/departments": "superAdminDepartments",
  "/u/super/admin/employees": "superAdminEmployees",
  "/u/super/admin/assignments": "superAdminAssignments",
  "/u/super/admin/roles": "superAdminRoles",
  "/u/super/admin/support": "superAdminSupport",
  "/u/super/admin/users": "superAdminUsers",
  "/u/super/admin/billing": "superAdminBilling",
  "/u/super/admin/ai-usage": "superAdminAiUsage",
  "/u/super/admin/institutions": "superAdminInstitutions",
  "/u/super/admin/influencers": "superAdminInfluencers",
  "/u/super/admin/domains": "superAdminDomains",
  "/u/admin": "superAdmin",
  "/u/admin/departments": "superAdminDepartments",
  "/u/admin/employees": "superAdminEmployees",
  "/u/admin/assignments": "superAdminAssignments",
  "/u/admin/roles": "superAdminRoles",
  "/u/admin/support": "superAdminSupport",
  "/u/admin/users": "superAdminUsers",
  "/u/admin/billing": "superAdminBilling",
  "/u/admin/ai-usage": "superAdminAiUsage",
  "/u/admin/institutions": "superAdminInstitutions",
  "/u/admin/influencers": "superAdminInfluencers",
  "/u/admin/domains": "superAdminDomains",
  "/u/admin/login": "supportLogin",
  "/u/admin/logout": "supportLogout",
};

const prefixRoutes = [
  { prefix: "/verify-email/", key: "verifyEmail" },
  { prefix: "/reset-password/", key: "resetPassword" },
  { prefix: "/resume-preview", key: "resumePreview" },
  { prefix: "/share/", key: "publicResumePreview" },
  { prefix: "/resume-edit/", key: "resumeEdit" },
  { prefix: "/prep-plan/", key: "planDetails" },
  { prefix: "/mock-test/", key: "mockTest" },
  { prefix: "/u/support/admin", key: "supportAdmin" },
  { prefix: "/u/support/agent", key: "supportPortal" },
  { prefix: "/u/support/login", key: "supportLogin" },
  { prefix: "/u/super/admin/departments", key: "superAdminDepartments" },
  { prefix: "/u/super/admin/employees", key: "superAdminEmployees" },
  { prefix: "/u/super/admin/assignments", key: "superAdminAssignments" },
  { prefix: "/u/super/admin/roles", key: "superAdminRoles" },
  { prefix: "/u/super/admin/support", key: "superAdminSupport" },
  { prefix: "/u/super/admin/users", key: "superAdminUsers" },
  { prefix: "/u/super/admin/billing", key: "superAdminBilling" },
  { prefix: "/u/super/admin/ai-usage", key: "superAdminAiUsage" },
  { prefix: "/u/super/admin/institutions", key: "superAdminInstitutions" },
  { prefix: "/u/super/admin/influencers", key: "superAdminInfluencers" },
  { prefix: "/u/super/admin/domains", key: "superAdminDomains" },
  { prefix: "/u/super/admin/coupons", key: "superAdminCouponsScope" },
  { prefix: "/u/admin/departments", key: "superAdminDepartments" },
  { prefix: "/u/admin/employees", key: "superAdminEmployees" },
  { prefix: "/u/admin/assignments", key: "superAdminAssignments" },
  { prefix: "/u/admin/roles", key: "superAdminRoles" },
  { prefix: "/u/admin/support", key: "superAdminSupport" },
  { prefix: "/u/admin/users", key: "superAdminUsers" },
  { prefix: "/u/admin/billing", key: "superAdminBilling" },
  { prefix: "/u/admin/ai-usage", key: "superAdminAiUsage" },
  { prefix: "/u/admin/institutions", key: "superAdminInstitutions" },
  { prefix: "/u/admin/influencers", key: "superAdminInfluencers" },
  { prefix: "/u/admin/domains", key: "superAdminDomains" },
  { prefix: "/u/admin/coupons", key: "superAdminCouponsScope" },
  { prefix: "/u/super/", key: "superAdmin" },
  { prefix: "/u/admin", key: "superAdmin" },
];

const prefetched = new Set();

export const prefetchRoute = (path) => {
  if (!path) return;
  const normalized = path.split("?")[0];
  let key = pathMap[normalized];

  if (!key) {
    const match = prefixRoutes.find((route) => normalized.startsWith(route.prefix));
    key = match?.key;
  }

  if (!key || prefetched.has(key)) return;
  const loader = routeChunks[key];
  if (!loader) return;

  prefetched.add(key);
  loader();
};

export const prefetchRoutes = (paths) => {
  if (!Array.isArray(paths)) return;
  paths.forEach(prefetchRoute);
};

export { routeChunks };
